export const BASE_URLS = {
  A1: '/shop',
  default: '/shop',
};
